import LazyFloatingAgent from '@/components/mobile/LazyFloatingAgent';
import { cn } from '@/lib/utils';
import { Fragment, Suspense } from 'react';
import { Home, Package, User, Wallet } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { onboardingTargetIds } from '@/features/Onboarding';
import { ruLabels } from '@/i18n/ru';

const tabs = [
  {
    hasEnd: true,
    icon: Home,
    id: 'home',
    label: ruLabels.navigation.home,
    path: '/'
  },
  {
    hasEnd: false,
    icon: Package,
    id: 'shipments',
    label: ruLabels.navigation.shipments,
    path: '/shipments'
  },
  {
    hasEnd: false,
    icon: Wallet,
    id: 'finance',
    label: ruLabels.navigation.finance,
    path: '/finance'
  },
  {
    hasEnd: false,
    icon: User,
    id: 'profile',
    label: ruLabels.navigation.profile,
    path: '/profile'
  }
];

const Nav = () => {
  const location = useLocation();
  const shouldShowFloatingAgent = location.pathname === '/';

  return (
    <nav className="relative flex w-full items-start justify-center gap-0 py-2" aria-label="Основная навигация">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const pairOffset = tab.id === 'home' || tab.id === 'shipments' ? '-translate-x-[1mm]' : 'translate-x-[1mm]';

        return (
          <Fragment key={tab.id}>
            {shouldShowFloatingAgent && tab.id === 'finance' && (
              <div className="flex min-w-0 flex-1 justify-center">
                <Suspense fallback={<span className="relative flex h-12 min-w-0 flex-1" aria-hidden="true" />}>
                  <LazyFloatingAgent
                    coachmarkTargetId={onboardingTargetIds.aiAgent}
                    placement="navigation"
                    size="mini"
                  />
                </Suspense>
              </div>
            )}
            <NavLink
              className={cn(
                'relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0 px-2 py-1',
                pairOffset
              )}
              end={tab.hasEnd}
              to={tab.path}
            >
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute inset-0 rounded-full bg-border" />}
                  <div className="relative z-10 flex flex-col items-center justify-center gap-0">
                    <Icon
                      className={cn('size-6 transition-colors', isActive ? 'text-accent' : 'text-muted-foreground')}
                      fill={isActive ? 'currentColor' : 'none'}
                      fillOpacity={isActive ? 0.12 : 0}
                      strokeWidth={isActive ? 2.25 : 1.75}
                    />
                    <span
                      className={cn(
                        'font-sans text-xs font-semibold leading-4 tracking-normal whitespace-nowrap transition-colors',
                        isActive ? 'text-accent' : 'text-muted-foreground'
                      )}
                    >
                      {tab.label}
                    </span>
                  </div>
                </>
              )}
            </NavLink>
          </Fragment>
        );
      })}
    </nav>
  );
};

export default Nav;